import { useState } from "react";

import InternationalPhoneInput from "@usas/ui-web/components/inputs/InternationalPhoneInput";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import { isValidUSOrCanadianPhoneNumber, isValidMexicanPhoneNumber } from "@usas/ui-web/utils/validation";

const ParentPhoneForm = ({
  parentPhoneData,
  onSubmitFormCallback,
  onSecondaryButtonClicked
}) => {
  const [formState, setFormState] = useState({
    parentPhone: parentPhoneData?.parentPhone || '+1'
  });
  const [errorState, setErrorState] = useState({
    parentPhone: ''
  });

  const onPhoneChanged = (value) => {
    setFormState(prev => ({
      ...prev,
      parentPhone: value
    }));
    
    // Clear error when user starts typing
    if (errorState.parentPhone) {
      setErrorState(prev => ({
        ...prev,
        parentPhone: ''
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formState.parentPhone?.trim() || formState.parentPhone.trim() === '+1') {
      errors.parentPhone = 'Parent/guardian phone number is required';
    } else {
      // Phone number validation using same logic as other forms
      const phoneNumber = formState.parentPhone.trim();
      if (!isValidUSOrCanadianPhoneNumber(phoneNumber) && !isValidMexicanPhoneNumber(phoneNumber)) {
        errors.parentPhone = 'Must enter a valid US, Canadian, or Mexican phone number in +1/+52 (XXX) XXX-XXXX format';
      }
    }
    
    setErrorState(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm() && onSubmitFormCallback) {
      onSubmitFormCallback(formState);
    }
  };

  const handleSecondaryClick = (e) => {
    e.preventDefault();
    
    if (onSecondaryButtonClicked) {
      onSecondaryButtonClicked(formState);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12">
          <InternationalPhoneInput
            label="Parent/Guardian Phone Number*"
            name="parentPhone"
            value={formState.parentPhone}
            error={!!errorState.parentPhone}
            message={errorState.parentPhone}
            country="US"
            onChange={onPhoneChanged}
          />
        </div>
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="submit">
            Continue
          </PrimaryButton>
        </div>
        <div className="col-xs-12 usas-extra-top-margin">
          <SecondaryButton onClick={handleSecondaryClick}>
            Back
          </SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default ParentPhoneForm;